import { Injectable } from '@angular/core';
import { User } from '../interfaces/user-interfaces';
import { UserService } from '../api/user.service';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  private user: User | null = null

  constructor(private userService: UserService, private router: Router) {
  }

  setUser(user: User): void {
    this.user = user;
  }

  getUser(): User | null {
    return this.user;
  }

  clearUser(): void {
    this.user = null;
  }

  async loadUserData(logoutOnFail: boolean = true): Promise<void> {
    // GET user data
    let userData = undefined;
    try {
      userData = await firstValueFrom(this.userService.getUserData());

      // Log out if no data for user
      if (!userData) {
        this.clearUser();
        if (logoutOnFail) {
          this.router.navigate(['/auth/logout/']);
        }
      }

      // Save user data
      this.setUser(userData as User);

    } catch (error) {
      // Log out if unauthorized
      if (error instanceof HttpErrorResponse) {
        if (error.status == 401 && error.error.code != 'SVC-4000') {
          this.user = null;
          if (logoutOnFail) {
            this.router.navigate(['/auth/logout/']);
          }
        }
      }
    }
  }
}
